import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommandBehavior, CommandType, QueryPlanDefinition, QueryPlanElementKind, SqlQueriesQueryPlanElementDefinition } from '../../services/api.services';

@Component({
  selector: 'query-plan-view',
  templateUrl: './QueryPlanViewComponent.html',
  styleUrl: './QueryPlanViewComponent.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QueryPlanViewComponent {
  readonly plan = input<QueryPlanDefinition>();

  readonly CommandType = CommandType;
  readonly CommandBehavior = CommandBehavior;

  readonly sqlQueries = computed(() =>
    this.plan()?.elements
      ?.filter(x => x.kind == QueryPlanElementKind.SqlQueries)
      .map(x => <SqlQueriesQueryPlanElementDefinition>x)
  );

  constructor() {
  }
}
